"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentTypes = void 0;
exports.ContentTypes = {
    Undefined: 0,
    KeyPerformanceIndicator: 1,
    Analysis: 100,
    Hypothesis: 200,
    Insight: 300,
    Topic: 400,
    Diagnostic: 500,
};
